export const styles = {
  background: "linear-gradient(180deg, rgba(8, 39, 70, 0.9) 0%, rgba(56, 198, 255, 0.9) 51%, rgba(255, 255, 255, 0.9) 81%, rgba(255, 255, 255, 1) 100%)",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "0 0, 50px 50px",
};
